import { BatchRunsTable } from '../components/BatchRunsTable';
import { LiveScansTable } from '../components/LiveScansTable';

export function LiveScansPage() {
  return (
    <div className="space-y-6">
      <BatchRunsTable />
      <LiveScansTable />
    </div>
  );
}
